import { NgModule} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from '../app.routes';
import { ImageListComponent } from './list/image-list.component';
import { CommonModule } from '../common/common.module';
import { SignModule } from '../sign/sign.module';
import { ImageUploadComponent } from './upload/image-upload.component';

@NgModule({
  imports: [BrowserModule, FormsModule, ReactiveFormsModule,  AppRoutingModule, CommonModule, SignModule],
  declarations: [ImageListComponent, ImageUploadComponent],
})
export class ImageHostingModule {}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/d90c5bcf/0/gaia/gaia-ui-angular/src/app/images/image-hosting.module.ts